import { adminHttpClient } from '../commons/adminHttpClient'

export interface CoverageProviderResponse {
  id: string
  name: string
  providerStartDate: string
}

export const getCoverageProviders = (
  date: string,
  familyMemberId?: string,
  showDistinctProviders = false,
): Promise<CoverageProviderResponse[]> => {
  return adminHttpClient.get(
    showDistinctProviders
      ? `/Expenses/CoverageProviders?startDate=${date}&familyMemberId=${
          familyMemberId ?? ''
        }&showDistinctProviders=true`
      : `/Expenses/CoverageProviders?startDate=${date}&familyMemberId=${familyMemberId ?? ''}`,
  )
}
